import { API, IImposiumAPI } from '@imposium-hub/components';

export const SERVICE_ID: number = 8;
export const APP_LABEL: string = 'Imposium Experience Manager';
export const api: IImposiumAPI = new API();
